import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useChatContext } from 'stream-chat-react';
import { useRouter } from '../../hooks/useRouter';
import { ChannelSort } from 'stream-chat';
import { useTheme } from '../../hooks/useTheme';

function RedirectFirstMessagePage() {
    const navigate = useNavigate();
    const { client } = useChatContext();
    const {navigateFromChannel} = useRouter();
    const {isMobile} = useTheme();
    const {tab} = useParams();
  
    useEffect(() => {
      const redirectToFirstChannel = async () => {
        try {
          // Get channels query
          const filter = { members: { $in: [client.userID || ''] } };
          const sort: ChannelSort = { last_message_at: -1 } as const;
          
          const channels = await client.queryChannels(filter, sort, {
            limit: 1,
          });
  
          if (channels && channels[0]) {
            navigateFromChannel(channels[0]);
          } else {
            return null;
          }
        } catch (error) {
          console.error('Error fetching channels:', error);
        }
      };
  
      if(!isMobile && tab === 'chat') {
        redirectToFirstChannel();
      }
    }, [navigate, client, navigateFromChannel, isMobile, tab]);
  
    return null; // or loading spinner if needed
}

export default RedirectFirstMessagePage;